import { render, staticRenderFns } from "./DatosInstantenos.vue?vue&type=template&id=78d864b6&scoped=true&"
import script from "./DatosInstantenos.vue?vue&type=script&lang=ts&"
export * from "./DatosInstantenos.vue?vue&type=script&lang=ts&"
import style0 from "./DatosInstantenos.vue?vue&type=style&index=0&id=78d864b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d864b6",
  null
  
)

export default component.exports